import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('manualOutboundCallStore')
@observer
class ManualOutboundCall extends Component {
  render() {
    const { manualOutboundCallStore, location } = this.props
    const { isFetching } = manualOutboundCallStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default ManualOutboundCall;
